<template>
  <div>
    <div class="form-group">
      <div class="d-flex flex-column align-items-center">
        <button class="fa mw-100" type="button" @click="$emit('cancelled')">
          <span class="fa-stack fa-primary">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-arrow-left fa-stack-1x fa-inverse"></i>
          </span>
        </button>
        <span v-if="loadingWidget" class="inline-loader" style="height: 3rem; width: 3rem;"></span>
      </div>
      <div id="sumup-card" class="mt-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SumUpWidget',
  props: {
    checkout: Object
  },
  data () {
    return {
      loadingWidget: {
        type: Boolean,
        default: true
      }
    }
  },
  computed: {
    providerReference () {
      return this.checkout ? this.checkout.providerReference : ''
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js'
    script.onload = () => {
      // eslint-disable-next-line no-undef
      SumUpCard.mount({
        id: 'sumup-card',
        checkoutId: this.providerReference,
        onResponse: (type, body) => {
          if (type === 'success') {
            this.$emit('completed')
          } else if (type === 'error') {
            this.$emit('errored', body.detail ? body.detail : 'An unknown error occurred.')
          }
        },
        onLoad: () => {
          this.loadingWidget = false
        }
      })
    }
    document.head.appendChild(script)
  }
}
</script>
